<template>
  <div>
    <Cell :class="[customClass, { 'wrap-cell-box': isWrap }]">
      <template #title>
        <div>{{ title }}</div>
      </template>
      <div v-if="isButton" @click="buttonClick">{{ buttonText }}</div>
      <!-- 如果value为空，显示暂无 -->
      <div
        v-else-if="
          (Array.isArray(getValue) && getValue.length === 0) ||
          ['', null, undefined].includes(getValue)
        "
        class="cell-data-box"
      >
        <div class="cell-value">{{ gettext('暂无') }}</div>
      </div>
      <!-- 从枚举中获取label -->
      <div v-else-if="options.length > 0" class="cell-data-box">
        <div class="cell-value">{{ getEnumLabel }}</div>
      </div>
      <!-- 如果value为数组，显示多行 -->
      <div v-else-if="Array.isArray(getValue)" class="cell-array-box">
        <div v-for="(item, index) in getValue" :key="index" class="cell-data-box cell-array-item">
          <div v-if="isLink" class="value-link" @click="jumpLink(item)">{{ item }}</div>
          <div v-else class="cell-value cell-array-item-value">{{ item }}</div>
          <div class="cell-icon-box">
            <i
              v-if="showCopyIcon && !['', null, undefined].includes(item)"
              class="icon-v3_outlined_copy"
              @click="copyValue(item)"
            />
            <i
              v-if="showPhoneIcon && !['', null, undefined].includes(item)"
              class="icon-v3_filled_phone"
              @click="callPhone(item)"
            />
          </div>
        </div>
      </div>
      <!-- 其他情况，显示value -->
      <div v-else class="cell-data-box">
        <div v-if="isLink" class="value-link" @click="jumpLink(getValue)">{{ getValue }}</div>
        <div v-else class="cell-value">{{ getValue }}</div>
        <div class="cell-icon-box">
          <i
            v-if="showCopyIcon && !['', null, undefined].includes(getValue)"
            class="icon-v3_outlined_copy"
            @click="copyValue(getValue)"
          />
          <i
            v-if="showPhoneIcon && !['', null, undefined].includes(getValue)"
            class="icon-v3_filled_phone"
            @click="callPhone(getValue)"
          />
        </div>
      </div>
    </Cell>
  </div>
</template>

<script>
import { Cell } from '@didi/rich-ui'
import { copyContent } from '@/common/utils/util'

export default {
  components: { Cell },
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      // Object是为了兼容poi信息
      type: [String, Number, Array, Object],
      default: () => '',
    },
    isLink: {
      type: Boolean,
      default: false,
    },
    showCopyIcon: {
      type: Boolean,
      default: false,
    },
    showPhoneIcon: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    isWrap: {
      type: Boolean,
      default: false,
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: '查看',
    },
    buttonClick: {
      type: Function,
      default: () => {
        console.log('buttonClick')
      },
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getEnumLabel() {
      if (this.options.length === 0) return ''
      return this.options.find(item => item.value === this.value)?.label || ''
    },
    getValue() {
      if (Array.isArray(this.value)) {
        const topFiltered = this.value.filter(item => item !== '')
        return this.flattenArrayValues(topFiltered)
      }
      return ['', null, undefined].includes(this.value) ? '' : this.value
    },
  },
  methods: {
    /** 把嵌套数组展平为一维，子项逐行展示；忽略各层中的空字符串 */
    flattenArrayValues(arr) {
      if (!Array.isArray(arr)) return arr
      const out = []
      for (const item of arr) {
        if (Array.isArray(item)) {
          out.push(...this.flattenArrayValues(item))
        } else if (item !== '') {
          out.push(item)
        }
      }
      return out
    },
    copyValue(value) {
      copyContent(value)
    },
    jumpLink(value) {
      if (['', null, undefined].includes(value)) return
      window.Soda.openPage({
        url: value,
        target: 'native',
      })
    },
    callPhone(value) {
      if (['', null, undefined].includes(value)) return false
      // 创建电话链接
      const telUrl = `tel:${value}`
      // 直接跳转拨号
      window.location.href = telUrl
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .rich-cell-wrapper {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .rich-cell-wrapper::after {
  border-bottom: 1px solid #ebebeb;
  webkit-transform: scale(1);
  transform: scale(1);
}
::v-deep .rich-cell-title {
  color: #595c66;
  font-size: 28px;
  font-family: 'DiDi Sans Pro';
  min-width: 240px;
}
.wrap-cell-box {
  ::v-deep .rich-cell-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 32px 0;
    .rich-cell-value {
      padding: 32px 0 0 0;
      line-height: 40px;
    }
  }
}
.cell-array-box {
  .cell-array-item {
    margin-bottom: 25px;
    justify-content: space-between;
  }
  .cell-array-item:last-child {
    margin-bottom: 0;
  }
}

.cell-data-box {
  display: flex;
  flex: 1;
  .cell-value {
    color: #282b33;
    font-size: 28px;
    font-weight: 500;
    font-family: 'DiDi Sans Pro';
    line-height: 37px;
  }
  .value-link {
    /* 默认状态 */
    color: #3b82f6;
    text-decoration: none;
    font-weight: 500;
    display: inline-block;
    padding: 8px 0;
    position: relative;

    /* 移除移动端点击灰色半透明层 */
    -webkit-tap-highlight-color: transparent;

    /* 增大点击区域 */
    -webkit-touch-callout: none;
    text-decoration: underline;
  }
  .cell-icon-box {
    i {
      margin-left: 10px;
      font-size: 30px;
      font-weight: bold;
    }
    .icon-v3_filled_phone {
      color: rgb(0, 172, 0);
    }
  }
}
</style>
